// usegetImages.js
import axios from "axios";

const useGetImages = () => {
  const getImages = async (element) => {
    const imageIds = element.map((data) => data.featured_media ?? null);

    const imageRequests = imageIds.map(async (imageId) => {
      if (!imageId) return;

      try {
        const imageResponse = await axios.get(window.location.origin + `/wp-json/wp/v2/media/${imageId}`);
        
        return imageResponse.data.source_url;
      } catch (error) {
        return "";
      }
    });

    const images = await Promise.all(imageRequests);

    return images; 
  };

  return { getImages };
};
 
export default useGetImages;
